import { Component } from '@angular/core';
import {NavController, AlertController, LoadingController, ToastController,reorderArray} from 'ionic-angular';
import { Params } from '../params';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import {CsvService} from "angular2-json2csv";
import { RouteMapPage } from "./map";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import {BeetrackProvider} from "../../providers/beetrack/beetrack";

@Component({
  selector: 'page-routes',
  templateUrl: 'routes.html'
})
export class RoutesPage {
  dia = moment().startOf('day').format();
  customers;
  routeSel;
  routes = [];
  group = {};
  data = [];
  showRoute : boolean = false;
  BAG = "DRAGULA_EVENTS";
  subs = new Subscription();
  array = [];
  max = String(moment().add(1, 'year').format("YYYY-MM-DD"));
  constructor(
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private navCtrl : NavController,
    private _csvService: CsvService,
    private dragulaService: DragulaService,
    private bee : BeetrackProvider){
    firebase.database().ref('/customers').once('value').then((snapshot)=>{
      this.customers = snapshot.val();
    });
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    this.findCharges();

    this.subs.add(dragulaService.drop(this.BAG)
      .subscribe(({el,source,target,sibling}) => {
        console.log(el,source,target,sibling);
        const belowId = getNodeindex(el);
        const itemId = el.getAttribute("id");

        function getNodeindex( elm ){
          try{
            console.log(elm)
            let c = elm.parentNode.children, i = 0;
            for(; i < c.length; i++ )
              if( c[i] == elm ) return i;
          }catch(e){
            console.log(e);
          }

        }

        this.moveCustomer(itemId,belowId)
        //this.removeClass(el, 'ex-moved');
      })
    );
  }

  moveCustomer(cust,pos){
    this.array.splice(this.array.indexOf(cust),1);
    this.array.splice(pos-1,0,cust);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }



  processCustomers(data){
    this.routes = [];
    this.group = {};

    for(let i=0;i<data.length;i++){
      if(data[i].shipping.noshipping_reason!="in"){
        let route = data[i].dispatch.route;
        if(route){
          if(this.routes.indexOf(route)==-1){
            this.routes.push(route);
            this.group[route] = {};
          }
          this.group[route][data[i].customer.id] = {};
          this.group[route][data[i].customer.id].customer = data[i].customer.id;
          this.group[route][data[i].customer.id].charge = data[i];
          this.group[route][data[i].customer.id].route_change = false;
        }
      }
    }
    this.routes.sort((a, b) => a - b);

    if(this.routes.length) this.showRoute = true;
  }

  changeInput(g){
    g.route_change = true;
  }

  saveChange(g){
    let route = '/customers/'+Params.md5(g.email)+'/route_pos';
    /* this.save = this.db.object(route);
    this.save.set(g.route_pos).then( _ => {
      g.route_change = false;
      let toast = this.toastCtrl.create({
        message: "Ruta actualizada correctamente "+g.name,
        duration: 3000
      });
      toast.present();
    }); */
  }

  pdf(){
    //console.log(this.group);
    let de = {
      content: [],
      pageMargins : [ 10, 10, 10, 10 ],
      styles: {
        table: {
          "fontSize": 8,
          "margin": [0, 0, 0, 0],
        }
      }
    };
    console.log(this.group)
    let total = Object.keys(this.group).length;
    let ok = 0;

    for(let r in this.group){
      firebase.database().ref('/routes/'+r).once('value').then((snapshot)=>{
        let route = (<any>Object).values(this.group[r]);
        if(snapshot.exists()){
          route = this.refreshRoutes(snapshot.val(),r);
        }else{
          route.sort( (a, b) => {
            if (Number(a.route_pos) > Number(b.route_pos)) {
              return 1;
            }
            if (Number(a.route_pos) < Number(b.route_pos)) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
        }
        de.content.push({text: "Ruta "+r+" del día "+moment(this.dia).format("DD/MM/YYYY"), margin: [ 0, 0, 0, 20 ], bold: true, fontSize: 15});
        de.content.push({
          style: 'table',
          table: {
            headerRows: 0,
            widths: ['auto', 'auto', '*'],
            body: [
              ['Repartidor',':',''],
              ['Total entregas',':',route.filter((x) => x.charge.shipping.delivered).length],
              ['Total comidas',':',route.filter((x) => x.charge.shipping.delivered).map((t) => t.charge.foods.hired.length).reduce((a, b) => a + b, 0)],
              ['Kms recorridos',':',''],
              ['Tag / Peaje',':',''],
            ]
          },
          margin: [ 0, 0, 0, 20 ],
          layout: 'lightHorizontalLines'
        })

        let body = [
          [
            {text: "Nombre", bold: true,fontSize:10},
            {text: "Dirección", bold: true,fontSize:10},
            {text: "Teléfono", bold: true,fontSize:10},
            {text: "Posición", bold: true,fontSize:10},
            {text: "Comidas", bold: true,fontSize:10},
            {text: "Observaciones", bold: true,fontSize:10},
            {text: "Entrega", bold: true,fontSize:10}
          ]
        ];
        console.log('route', route);
        for(let us in route){
          let user = route[us];
          if(user.charge.shipping.delivered){
            body.push([
              user.charge.customer.name+" "+user.charge.customer.lastname,
              user.charge.dispatch.address+" "+user.charge.dispatch.address_info,
              user.charge.customer.phone,
              Number(us)+1,
              user.charge.foods.hired.length +" ["+user.charge.foods.hired.join(",")+"]",
              user.charge.dispatch.observation,
              user.charge.shipping.delivered ? 'Si' : 'No'
            ])
          }

        }
        de.content.push({
          style: 'table',
          table: {
            headerRows: 0,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto','auto','auto'],
            body: body
          },
          layout: 'lightHorizontalLines'
        })
        de.content.push({text: '---', pageBreak: 'after'})
        ok++;
        if(total==ok){
          pdfMake.createPdf(de).open();
        }
      });
    }
  }

  xls(){
    let ok = [];
    let cu = (<any>Object).values(this.group[this.routeSel]);
    cu.sort(function (a, b) {
      if (Number(a.route_pos) > Number(b.route_pos)) {
        return 1;
      }
      if (Number(a.route_pos) < Number(b.route_pos)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    for(let i=0;i<cu.length;i++){
      let c = cu[i];
      let s = {
        "Cliente" : Params.parse_xls(c.charge.customer.name)+" "+Params.parse_xls(c.charge.customer.lastname),
        "Rut": c.charge.customer.rut ? c.charge.customer.rut : 'sin datos',
        "Email": c.charge.customer.email ? c.charge.customer.email : 'sin datos',
        "Direccion": c.charge.dispatch.address ? Params.parse_xls(c.charge.dispatch.address)+ ", "+ Params.parse_xls(c.charge.dispatch.address_info) : 'sin datos',
        "Comidas": c.charge.foods.hired ? c.charge.foods.hired : 'sin datos',
        "Telefono": c.charge.customer.phone ? c.charge.customer.phone : 'sin datos',
        "Plan": c.charge.customer.plan.code ? c.charge.customer.plan.code : 'sin datos',
        "Ruta": c.charge.dispatch.route ? c.charge.dispatch.route : 'sin datos',
        "Ruta Posicion": c.charge.dispatch.position ? c.charge.dispatch.position : 'sin datos',
        "Ruta Observaciones": c.charge.dispatch.observation ? c.charge.dispatch.observation : 'sin datos',
        "Entregar": c.charge.shipping.delivered ? 'Si' : 'No'
      };
      ok.push(s);
    }

    this._csvService.download(ok, 'Ruta_'+this.routeSel);
  }


  count(data){
    const array = (<any>Object).keys(data).map((x) => {
      return data[x];
    }).filter((x) => x.charge.shipping.delivered)

    return array.length;
  }

  sendBeetrack(){
    const alert = this.alertCtrl.create();
    alert.setTitle('Seleccione rutas');
    for(let r of this.routes){
      alert.addInput({
        type: 'checkbox',
        label: 'Ruta '+r+' ('+this.count(this.group[r])+' despachos)',
        value: r
      });
    }
    alert.addButton('Cancelar');
    alert.addButton({
      text: 'Siguiente',
      handler: data => {
        let count = 0;
        let arrs = {};
        if(data.length){
          for(let de of data){
            firebase.database().ref('/routes/'+de).once('value').then((snapshot)=> {
              if (snapshot.exists()) {
                arrs[de] = snapshot.val();
              }
              count++;
              if(data.length == count){
                let dispatches = [];
                for(let d of data){
                  let cu = this.refreshRoutes(arrs[d], d)
                  for(let i=0;i<cu.length;i++){
                    let c = cu[i];
                    const day_format =  moment(this.dia).format("YYYYMMDD");
                    if(c.charge.shipping.delivered){
                      const dispatch = {
                        "identifier" : 'GUI-'+day_format+'-'+c.charge.dispatch.route+'-'+c.customer,
                        "contact_name" : c.charge.customer.name+" "+c.charge.customer.lastname,
                        "contact_address" : c.charge.dispatch.address,
                        "contact_phone" : c.charge.customer.phone,
                        "contact_email" : c.charge.customer.email,
                        "contact_id" : c.charge.customer.email,
                        "latitude" : c.charge.dispatch.location.lat,
                        "longitude" : c.charge.dispatch.location.lng,
                        "min_delivery_time": moment(this.dia).format("YYYY-MM-DD")+" 01:00:00-0300",
                        "max_delivery_time": moment(this.dia).format("YYYY-MM-DD")+" 23:59:00-0300",
                        "tags" : [ {  "name": "address_info", "value": c.charge.dispatch.address_info}],
                        "items": [],
                        "priority": 1,
                        "service_time" : 1,
                        "load" : 1
                      }
                      for(let f=0;f<c.charge.foods.detail.length;f++){
                        if(c.charge.foods.detail[f]){
                          dispatch.items.push({
                            "code" : c.charge.foods.detail[f].code,
                            "height": 1,
                            "lenght": 1,
                            "width": 1,
                            "weight": 1,
                            "qty" : 1,
                            "name" : c.charge.foods.detail[f].prod.name
                          })
                        }
                      }
                      dispatches.push(dispatch);
                    }
                  }
                }
                const alert2 = this.alertCtrl.create({
                  title: 'Código Repartidor YLE',
                  inputs: [
                    {
                      name: 'car',
                      placeholder: '2jF4e82LJ6UEql23MrLyiqBQAi43',
                      value: ''
                    }
                  ],
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                      handler: data => {
                        console.log('Cancel clicked');
                      }
                    },
                    {
                      text: 'Enviar ruta',
                      handler: rdata => {
                        if (rdata.car!='') {
                          const route = {
                            dispatches : dispatches,
                            truck_identifier : rdata.car,
                            date: moment(this.dia).subtract(1, 'day').format("YYYY-MM-DD")
                          }
                          this.bee.createRoute(route).then((data)=>{
                            console.log(data);
                            let toast = this.toastCtrl.create({
                              message: 'Ruta creada exitosamente.',
                              duration: 3000
                            });
                            toast.present();
                          }).catch((e)=>{
                            console.log("error",e)
                            let toast = this.toastCtrl.create({
                              message: 'No se pudo crear la ruta en YLE.'+e._body,
                              duration: 3000
                            });
                            toast.present();
                          })
                        } else {
                          // invalid login
                          return false;
                        }
                      }
                    }
                  ]
                });
                alert2.present();
              }
            });
          }
        }else{
          return false;
        }
      }
    });
    alert.present();
  }

  refreshRoutes(values,route){
    let data = []
    try{
      for(let i of values){
        if(this.group[route][i]){
          this.group[route][i].new = false;
          data.push(this.group[route][i])
        }else{
          this.array.splice(values.indexOf(i),1)
        }
      }
      console.log(values.length,Object.keys(this.group[route]).length)

      let keys = Object.keys(this.group[route]);
      for(let i=0;i<keys.length;i++){
        if(values.indexOf(keys[i])<0){
          this.array.push(keys[i]);
          this.group[route][keys[i]].new = true;
          data.push(this.group[route][keys[i]])
        }
      }
      console.log(this.array.length);

    }catch(e){
      console.error(e);
    }
    return data;
  }

  showCustomers(){
    firebase.database().ref('/routes/'+this.routeSel).once('value').then((snapshot)=>{
      if(snapshot.exists()){
        this.array = snapshot.val();
        this.data = this.refreshRoutes(snapshot.val(),this.routeSel);
      }else{
        this.data = (<any>Object).values(this.group[this.routeSel]);
        this.data.sort(function (a, b) {
          if (Number(a.route_pos) > Number(b.route_pos)) {return 1;}
          if (Number(a.route_pos) < Number(b.route_pos)) {return -1;}
          return 0;
        });
        this.array = [];
        this.data.map((x)=>{
          this.array.push(x.customer);
        })

        //this.array = Object.keys(this.group[this.routeSel]);
      }
    });

    console.log(this.group);
  }

  savePositions(){
    let route = '/routes/'+this.routeSel;
    firebase.database().ref(route).set(this.array)
      .then(()=>{
        this.data = this.refreshRoutes(this.array,this.routeSel);
        let toast = this.toastCtrl.create({
          message: "Rutas actualizadas correctamente ",
          duration: 3000
        });
        toast.present();
      })
  }

  map(){
    console.log(this.group[this.routeSel],this.array)
    this.navCtrl.push(RouteMapPage,{markers:this.group[this.routeSel],positions:this.array});
  }

  findCharges(){
    this.routeSel = null;
    let loading = this.loadingCtrl.create({
      content: 'Buscando rutas...'
    });
    loading.present();
    setTimeout(()=>{
      this.dia = this.dia.substr(0,10);
      let day = moment(this.dia).format("YYYYMMDD");
      firebase.firestore().collection('orders').doc(day).collection('data')
        // .where('shipping.delivered','==',true)
        .get().then((snapshot)=>{
        loading.dismiss();
        if(!snapshot.empty){
          const charges = [];
          snapshot.forEach((doc)=>{
            charges.push({id:doc.id,...doc.data()})
          });
          this.processCustomers(charges);
        }else{
          let alert = this.alertCtrl.create({
            title: 'No se han impreso etiquetas',
            subTitle: 'Aún no se imprimen etiquetas para el día seleccionado',
            buttons: ['Aceptar']
          });
          alert.present();
        }
      });
    },100)

  }

}



// WEBPACK FOOTER //
// ./src/pages/routes/routes.ts